import { useTranslation } from '@pancakeswap/localization'
import { ChainId, CurrencyAmount, ERC20Token, Percent } from '@pancakeswap/sdk'
import { pDAI, pUSDC, pUSDT } from '@pancakeswap/tokens'
import { AutoColumn, Balance, Box, Button, CopyButton, Dots, Flex, FlexGap, IconButton, Modal, Text, useModal } from '@pancakeswap/uikit'
import { CommitButton } from 'components/CommitButton'
import ConnectWalletButton from 'components/ConnectWalletButton'
import CurrencyInputPanel from 'components/ECurrencyInputPanel'
import { useCurrency } from 'hooks/Tokens'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useCallback, useMemo, useState } from 'react'
import styled from 'styled-components'
// import { StableConfigContext, useStableSwapContract, useStableSwapInfoContract } from 'views/Swap/hooks/useStableConfig'
import NineInchConfig from '@9inch/config'
import { StableSwap } from '@pancakeswap/smart-router/evm'
import { parseUnits } from '@pancakeswap/utils/viem/parseUnits'
import TransactionConfirmationModal, { TransactionSubmittedContent } from 'components/TransactionConfirmationModal'
import { ApprovalState, useApproveCallback } from 'hooks/useApproveCallback'
import useCatchTxError from "hooks/useCatchTxError"
import { useStableSwapInfo } from 'hooks/useStableSwapInfo'
import { useFeeDataWithGasPrice } from "state/user/hooks"
import { useCurrencyBalances } from 'state/wallet/hooks'
import { Address } from 'viem'
import { useStableSwapTripleContract } from 'views/Swap/hooks/useStableConfig'
import AddToWalletButton from 'components/AddToWallet/AddToWalletButton'


const Wrapper = styled(Flex)`
  position: relative;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  gap: 4px;
  & > div {
    background: #2B2634;
  }
`

const Info = styled(Box)`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr;
  row-gap: 12px;
`

const StyledButton = styled(IconButton)`
  background: #FCFCFD33;
  backdrop-filter: blur(100px);
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin: -20px auto;
  position: relative;
  z-index: 2;
  cursor: pointer;
  &:hover {
    opacity: 0.65;
  }
`

interface AddModalProps {
  onDone?: () => void
  onDismiss?: () => void
}

const AddModalStable: React.FC<AddModalProps> = ({
  onDone,
  onDismiss
}) => {
  const { t } = useTranslation()
  const { account, isWrongNetwork } = useActiveWeb3React()
  const [attemptingTxn, setAttemptingTxn] = useState(false)
  const [txHash, setTxHash] = useState<string>('')
  const [attemptingApprove, setAttemptingApprove] = useState<boolean[]>([false, false, false])

  const [typedAmount0, setTypedAmount0] = useState('')
  const [typedAmount1, setTypedAmount1] = useState('')
  const [typedAmount2, setTypedAmount2] = useState('')

  const currency0 = useCurrency(pUSDC[ChainId.PULSE].address)
  const currency1 = useCurrency(pUSDT[ChainId.PULSE].address)
  const currency2 = useCurrency(pDAI[ChainId.PULSE].address)

  const currencies = useMemo(() => [currency0, currency1, currency2].filter((a) => a !== undefined), [currency0, currency1, currency2])
  const orders = [0, 1, 2].sort((a, b) => {
    return currencies[a].wrapped.sortsBefore(currencies[b].wrapped) ? -1 : 1
  })
  // const ordered = (arr: any[]) => {
  //   return arr.map((_, i) => arr[orders[i]])
  // }
  const amounts = useMemo(() => [
    typedAmount0,
    typedAmount1,
    typedAmount2,
  ], [typedAmount0, typedAmount1, typedAmount2])

  const parsedAmount0 = useMemo(() => CurrencyAmount.fromRawAmount(currency0, parseUnits(typedAmount0, currency0.decimals)), [currency0, typedAmount0])
  const parsedAmount1 = useMemo(() => CurrencyAmount.fromRawAmount(currency1, parseUnits(typedAmount1, currency1.decimals)), [currency1, typedAmount1])
  const parsedAmount2 = useMemo(() => CurrencyAmount.fromRawAmount(currency2, parseUnits(typedAmount2, currency2.decimals)), [currency2, typedAmount2])

  const parsedAmounts = useMemo(() => [parsedAmount0, parsedAmount1, parsedAmount2], [parsedAmount0, parsedAmount1, parsedAmount2])
  const balances = useCurrencyBalances(
    account,
    useMemo(() => [currency0, currency1, currency2], [currency0, currency1, currency2]),
  )

  // const expertMode = useIsExpertMode()
  // const [slippage] = useUserSlippagePercent()
  // const [onPresentSettingsModal] = useModal(<SettingsModal mode={SettingsMode.SWAP_LIQUIDITY} />)

  const poolAPR = 0
  const chainId = ChainId.PULSE

  //  const stableSwapContract = useStableSwapContract()
  const stableSwapContract = useStableSwapTripleContract(NineInchConfig[chainId].SwapContract_USDC_USDT_DAI as `0x${string}`)
  const lpToken = useCurrency(NineInchConfig[chainId].pUSD)

  const { totalSupply, balances: lpBalances, amplifier, loading } = useStableSwapInfo(
    NineInchConfig[chainId].SwapContract_USDC_USDT_DAI as Address,
    NineInchConfig[chainId].pUSD as Address,
  )

  const [lpOutput, shareOfPool] = useMemo(() => {
    if (loading)
      return [undefined, 0]
    const output = StableSwap.getLPOutputWithoutFee({
      amplifier,
      balances: lpBalances.map((bal, i) => CurrencyAmount.fromRawAmount(currencies[orders[i]], bal)),
      totalSupply: CurrencyAmount.fromRawAmount(lpToken, totalSupply),
      amounts: [parsedAmounts[orders[0]], parsedAmounts[orders[1]], parsedAmounts[orders[2]]],
    })
    return [
      output, totalSupply ? Number(new Percent(output.quotient, totalSupply + output.quotient).toFixed(1)) : 0
    ]
  }, [amplifier, currencies, loading, lpBalances, lpToken, orders, parsedAmounts, totalSupply])

  const { approvalState: approvalA, approveCallback: approveACallback } = useApproveCallback(
    parsedAmount0,
    stableSwapContract?.address,
  )
  const { approvalState: approvalB, approveCallback: approveBCallback } = useApproveCallback(
    parsedAmount1,
    stableSwapContract?.address,
  )
  const { approvalState: approvalC, approveCallback: approveCCallback } = useApproveCallback(
    parsedAmount2,
    stableSwapContract?.address,
  )

  const { fetchTxResponse } = useCatchTxError()
  const { gasPrice } = useFeeDataWithGasPrice()


  const [onPresentResultModal] = useModal(
    <TransactionConfirmationModal
      minWidth={['100%', null, '420px']}
      title={t('Add pStable LP')}
      attemptingTxn={false}
      hash={txHash}
      content={() =>
        <TransactionSubmittedContent
          chainId={chainId}
          hash={txHash}
          onDismiss={() => {
            onDone?.()
            onDismiss?.()
          }}
          currencyToAdd={lpToken}
        />
      }
      pendingText={''}
    />,
    true,
    true,
    'TransactionSubmittedModal',
  )

  const onAdd = useCallback(async () => {
    if (!account || !stableSwapContract || !currency0 || !currency1 || !currency2) return

    const tokenAmounts = [
      parseUnits(typedAmount0 ?? '0', currency0.decimals),
      parseUnits(typedAmount1 ?? '0', currency1.decimals),
      parseUnits(typedAmount2 ?? '0', currency2.decimals),
    ]

    // const minLPOutput = calculateSlippageAmount(lpOutputWithoutFee, allowedSlippage)[0]

    setAttemptingTxn(true)
    fetchTxResponse(() => stableSwapContract.write.add_liquidity([[tokenAmounts[orders[0]], tokenAmounts[orders[1]], tokenAmounts[orders[2]]], 0n], {
      // gas: DEFAULT_GAS_LIMIT,
      gasPrice,
      account: stableSwapContract.account,
      chain: stableSwapContract.chain,
    }), {
      type: 'add-liquidity-stable',
      summary: `Add ${currencies.map((c, i) => `${amounts[i]} ${c.symbol}`).filter((c, i) => amounts[i]).join(' and ')}`,
      translatableSummary: {
        text: `Add ${currencies.map((_, i) => `%amount${i}% %symbol${i}%`).filter((c, i) => amounts[i]).join(' and ')}`,
        data: {
          amount0: typedAmount0,
          symbol0: currency0?.symbol,
          amount1: typedAmount1,
          symbol1: currency1?.symbol,
          amount2: typedAmount2,
          symbol2: currency2?.symbol,
        },
      },
    })
      .then(tx => {
        setTxHash(tx.hash)
        onPresentResultModal()
      })
      .catch((ex) => { console.error('add_liquidity error', ex) })
      .finally(() => setAttemptingTxn(false))
  }, [account, stableSwapContract, currency0, currency1, currency2, typedAmount0, typedAmount1, typedAmount2, fetchTxResponse, currencies, orders, gasPrice, amounts, onPresentResultModal])

  const handleDismiss = useCallback(() => {
    onDismiss?.()
  }, [onDismiss])

  const notApprovalYet =
    (parsedAmount0?.greaterThan(0) && approvalA !== ApprovalState.APPROVED) ||
    (parsedAmount1?.greaterThan(0) && approvalB !== ApprovalState.APPROVED) ||
    (parsedAmount2?.greaterThan(0) && approvalC !== ApprovalState.APPROVED)

  const errorText = useMemo(() => {
    if (!parsedAmounts.find(v => v && v.greaterThan(0n)))
      return t("Enter an amount")
    const hasLowBalance = parsedAmounts.find((v, i) => v && v.greaterThan(balances && balances[i] ? balances[i] : 0n))
    if (hasLowBalance)
      return t("Insufficient %symbol% balance", { symbol: hasLowBalance.currency.symbol })
    return undefined
  }, [balances, parsedAmounts, t])

  const pendingText = useMemo(
    () => `Add ${currencies.map((c, i) => `${amounts[i]} ${c.symbol}`).filter((c, i) => amounts[i]).join(' and ')}`,
    [currencies, amounts],
  )

  const [onPresentConfirmModal] = useModal(
    <TransactionConfirmationModal
      minWidth={['100%', null, '420px']}
      title={t('Add Liquidity')}
      attemptingTxn={attemptingTxn}
      hash={txHash}
      content={() => null}
      pendingText={pendingText}
    />,
    false,
    true,
    'TransactionConfirmationModal',
  )

  const isValid = !errorText

  const buttonDisabled = !isValid || notApprovalYet // || (slippageSeverity > 2 && !expertMode)

  const showFieldAApproval = approvalA === ApprovalState.NOT_APPROVED || approvalA === ApprovalState.PENDING
  const showFieldBApproval = approvalB === ApprovalState.NOT_APPROVED || approvalB === ApprovalState.PENDING
  const showFieldCApproval = approvalC === ApprovalState.NOT_APPROVED || approvalC === ApprovalState.PENDING

  const shouldShowApprovalGroup = (showFieldAApproval || showFieldBApproval || showFieldCApproval) && isValid

  // useEffect(() => {
  //   if (!account || !stableSwapContract || !currency0 || !currency1 || !currency2) return

  //   const orders = [0, 1, 2].sort((a, b) => {
  //     return currencies[a].wrapped.sortsBefore(currencies[b].wrapped) ? -1 : 1
  //   })

  //   const tokenAmounts = [
  //     parseUnits(typedAmount0 ?? '0', currency0.decimals),
  //     parseUnits(typedAmount1 ?? '0', currency1.decimals),
  //     parseUnits(typedAmount2 ?? '0', currency2.decimals),
  //   ]

  //   stableSwapContract.simulate.add_liquidity([[tokenAmounts[orders[0]], tokenAmounts[orders[1]], tokenAmounts[orders[2]]], 0n]).then((res) => {
  //     console.log('add_liquidity simulate', res)
  //   }).catch((ex) => {
  //     console.error('add_liquidity error', ex)
  //   })

  // }, [account, currencies, currency0, currency1, currency2, stableSwapContract, typedAmount0, typedAmount1, typedAmount2])

  return (
    <Modal title="Add pStable Liquidity" headerBackground="gradientCardHeader" onDismiss={handleDismiss}>
      <Box p={2} mb={2} bg="#FFFFFF0D" borderRadius={6}>
        <Text fontSize={14}>
          Provide any amounts of pDAI, pUSDT, and pUSDC and get <strong>pStable LP</strong> in return. <br />
          <strong>pStable LP</strong> is a tradable LP token that represents the combined pStablecoins plus the yield they generate in the pool.
          You can swap <strong>pStable LP</strong> and get back pStables at any time.  <br />
          By participating in the pStable Pool, you assume equal value between all pStables.
        </Text>
        {
          !!lpToken &&
          <FlexGap gap="8px" alignItems="center" mt={1}>
            <Text fontSize={14} pl={2}>
              <strong>pStableLP</strong> contract: {lpToken.wrapped.address.slice(0, 6)}...{lpToken.wrapped.address.slice(-4)}
            </Text>
            <CopyButton
              width="16px"
              buttonColor="textSubtle"
              text={lpToken.wrapped.address}
              tooltipMessage={t('Token address copied')}
            />
            <AddToWalletButton
              variant="text"
              p="0"
              height="auto"
              width="fit-content"
              tokenAddress={lpToken.wrapped.address}
              tokenSymbol="pUSD"
              tokenDecimals={lpToken.decimals}
              tokenLogo={`https://pdex.vision/images/symbols/pusd.png`}
            />
          </FlexGap>
        }
      </Box>
      <Wrapper>
        <CurrencyInputPanel
          id="pool-currency0"
          showUSDPrice
          showMaxButton
          showCommonBases
          value={typedAmount0}
          currency={currency0}
          onUserInput={setTypedAmount0}
          disableCurrencySelect
          componentFor="liquidity"
        />
        <CurrencyInputPanel
          id="pool-currency1"
          showUSDPrice
          showMaxButton
          showCommonBases
          value={typedAmount1}
          currency={currency1}
          onUserInput={setTypedAmount1}
          disableCurrencySelect
          componentFor="liquidity"
        />
        <CurrencyInputPanel
          id="pool-currency2"
          showUSDPrice
          showMaxButton
          showCommonBases
          value={typedAmount2}
          currency={currency2}
          onUserInput={setTypedAmount2}
          disableCurrencySelect
          componentFor="liquidity"
        />
      </Wrapper>
      <Info my="8px" p="12px">
        <div>
          <Text fontSize={13} color="textSubtle">{t('You will receive:')}</Text>
          <Balance fontSize={14} value={Number(lpOutput?.toExact() ?? 0)} unit=" pUSD" />
          {/* <Text fontSize={14} ellipsis>1 {currency0?.symbol} = 1 {currency1?.symbol} = 1 {currency2?.symbol}</Text> */}
        </div>
        <div>
          <Text fontSize={13} color="textSubtle">{t('Share of Pool')}</Text>
          <Text fontSize={14}>{shareOfPool}%</Text>
        </div>
        {/* <div>
          <FlexGap gap="8px" alignItems="center">
            <Text fontSize={13} color="textSubtle">{t('Slippage Tolerance')}</Text>
            <PencilIcon width={10} color="textSubtle" onClick={onPresentSettingsModal} />
          </FlexGap>
          <Text fontSize={14}>{slippage.toFixed(1)}%</Text>
        </div> */}
        <div>
          <Text fontSize={13} color="textSubtle">{t('LP reward APR')}</Text>
          <Text fontSize={14}>{poolAPR.toFixed(2)}%</Text>
        </div>
      </Info>
      {
        !account
          ? <ConnectWalletButton width="100%" style={{ minHeight: '72px', fontFamily: 'IBM Plex Sans' }} />
          : <AutoColumn gap="md">
            {shouldShowApprovalGroup && (
              <FlexGap gap="8px">
                {showFieldAApproval && (
                  <Button onClick={() => {
                    setAttemptingApprove(attempting => [true, attempting[1], attempting[2]])
                    approveACallback().finally(() => setAttemptingApprove(attempting => [false, attempting[1], attempting[2]]))
                  }} disabled={approvalA === ApprovalState.PENDING || attemptingApprove[0]} width="100%"
                    style={{ minHeight: '72px', fontFamily: 'IBM Plex Sans' }}
                  >
                    {approvalA === ApprovalState.PENDING || attemptingApprove[0] ? (
                      <Dots>{t('Enabling %asset%', { asset: currency0?.symbol })}</Dots>
                    ) : (
                      t('Enable %asset%', { asset: currency0?.symbol })
                    )}
                  </Button>
                )}
                {showFieldBApproval && (
                  <Button onClick={() => {
                    setAttemptingApprove(attempting => [attempting[0], true, attempting[2]])
                    approveBCallback().finally(() => setAttemptingApprove(attempting => [attempting[0], false, attempting[2]]))
                  }} disabled={approvalB === ApprovalState.PENDING || attemptingApprove[1]} width="100%"
                    style={{ minHeight: '72px', fontFamily: 'IBM Plex Sans' }}
                  >
                    {approvalB === ApprovalState.PENDING || attemptingApprove[1] ? (
                      <Dots>{t('Enabling %asset%', { asset: currency1?.symbol })}</Dots>
                    ) : (
                      t('Enable %asset%', { asset: currency1?.symbol })
                    )}
                  </Button>
                )}
                {showFieldCApproval && (
                  <Button onClick={() => {
                    setAttemptingApprove(attempting => [attempting[0], attempting[1], true])
                    approveCCallback().finally(() => setAttemptingApprove(attempting => [attempting[0], attempting[1], false]))
                  }} disabled={approvalC === ApprovalState.PENDING || attemptingApprove[2]} width="100%"
                    style={{ minHeight: '72px', fontFamily: 'IBM Plex Sans' }}
                  >
                    {approvalC === ApprovalState.PENDING || attemptingApprove[2] ? (
                      <Dots>{t('Enabling %asset%', { asset: currency2?.symbol })}</Dots>
                    ) : (
                      t('Enable %asset%', { asset: currency2?.symbol })
                    )}
                  </Button>
                )}
              </FlexGap>
            )}
            <CommitButton
              variant={buttonDisabled ? 'danger' : 'primary'}
              onClick={() => {
                onPresentConfirmModal()
                onAdd()
              }}
              style={{ minHeight: '72px', fontFamily: 'IBM Plex Sans' }}
              disabled={buttonDisabled}
            >
              {errorText || t('Add')}
            </CommitButton>
          </AutoColumn>
      }
    </Modal>
  )
}

export default AddModalStable
